export default "__VITE_ASSET__CzDVP5js__"